/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { propsUtils } from '@ba-ui-toolkit/utils';
import { CodeSnippet as CarbonCodeSnippet } from 'carbon';

const { BaPropTypes } = propsUtils;

export default class CodeSnippet extends Component {
	static propTypes = {
		buttonAriaLabel: BaPropTypes.deprecated(
			'is ignored and not applicable to carbon code snippet'
		),
		className: PropTypes.string,
		labelFormatter: BaPropTypes.deprecated(
			'is ignored and not applicable to carbon code snippet'
		),
		onCopy: PropTypes.func,
		/** Source code to be pre-filled into the snippet */
		value: PropTypes.string,
		/** Flag to set for the mode of snippet */
		editable: BaPropTypes.deprecated('is ignored and not applicable to carbon code snippet'),
		/** Width (unit: px) of Code Snippet Div. For the static codeSnippet, the min-width is 356px; for the editable, the min-width is 500px. */
		width: BaPropTypes.deprecated('is ignored and not applicable to carbon code snippet'),
		/** Height (unit: px) of Code Snippet Div. For the static codeSnippet, the min-height is 88px; for the editable, the min-height is 200px. */
		height: BaPropTypes.deprecated('is ignored and not applicable to carbon code snippet'),
		/** Enforce pasted content to be filled into one-line in editable codeSnippet (temporary prop, only available for editable codeSnippet) */
		singleLinePaste: BaPropTypes.deprecated(
			'is ignored and not applicable to carbon code snippet'
		),
	};

	render() {
		const {
			labelFormatter,
			value,
			buttonAriaLabel,
			editable,
			width,
			height,
			singleLinePaste,
			onCopy,
			...others
		} = this.props;

		return (
			<CarbonCodeSnippet {...others} onClick={onCopy} type="multi">
				{value}
			</CarbonCodeSnippet>
		);
	}
}
